import { render, staticRenderFns } from "./HistoryTasks.vue?vue&type=template&id=64c3384f&scoped=true"
import script from "./HistoryTasks.vue?vue&type=script&lang=js"
export * from "./HistoryTasks.vue?vue&type=script&lang=js"
import style0 from "./HistoryTasks.vue?vue&type=style&index=0&id=64c3384f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3384f",
  null
  
)

export default component.exports